/** Shared palette for todos & calendar events (hex). */

export const DEFAULT_ITEM_COLOR = '#0ea5e9';

export const HAYDI_ITEM_COLORS = [
  { id: 'sky', hex: '#0ea5e9' },
  { id: 'indigo', hex: '#6366f1' },
  { id: 'violet', hex: '#8b5cf6' },
  { id: 'fuchsia', hex: '#d946ef' },
  { id: 'rose', hex: '#f43f5e' },
  { id: 'orange', hex: '#ea580c' },
  { id: 'amber', hex: '#d97706' },
  { id: 'emerald', hex: '#059669' },
  { id: 'slate', hex: '#475569' },
];

export function normalizeItemColor(hex) {
  if (typeof hex !== 'string' || !/^#[0-9A-Fa-f]{6}$/.test(hex.trim())) {
    return DEFAULT_ITEM_COLOR;
  }
  return hex.trim().toLowerCase();
}

export function eventColorHex(ev) {
  return normalizeItemColor(ev?.color);
}
